import image1 from "../src/images/Full_stack_developer-1-1.jpg";
import image2 from "../src/images/android.png";
import image3 from "../src/images/Cloud-computing.jpg";
import image4 from "../src/images/bigdata.jpg";
import image5 from "../src/images/ml.jpg";
import image6 from "../src/images/Java3.jpg";

const data = [
  {
    title: "Android Development",
    description:
      "Learn about basics of Android Development and " +
      "get started with building the Android Applications with confidence.",
    content: "Java , Android SDK , Git , Github and more...",
    img: image2,
    creator: "Yashraj verma",
    course_content: [
      "3 hours+ on-demand video content",
      " 14 hands-on-keyboard exercises",
      " This course + all other course access (CareerGrads)",
      " Full lifetime access (Purchase On CareerGrads)",
      " Certificate of completion",
    ],
  },
  {
    title: "Web Development",
    description:
      "Learn about basics of Web Development and " +
      "get started with building the Web Applications with confidence.",
    content: "HTML , CSS , JavaScript , Reactjs ,Github and more...",
    img: image1,
    creator: "Yashraj verma",
    course_content: [
      "3 hours+ on-demand video content",
      " 14 hands-on-keyboard exercises",
      " This course + all other course access (CareerGrads)",
      " Full lifetime access (Purchase On CareerGrads)",
      " Certificate of completion",
    ],
  },
  {
    title: "Cloud Computing",
    description:
      "Learn about the fundamentals of Cloud Computing and " +
      "get started with building the Web Applications with confidence.",
    content:
      "Deployment Models , Delivery Models , Virtualization , Hosting , Different Platforms and more...",
    img: image3,
    creator: "Yashraj verma",
    course_content: [
      "3 hours+ on-demand video content",
      " 14 hands-on-keyboard exercises",
      " This course + all other course access (CareerGrads)",
      " Full lifetime access (Purchase On CareerGrads)",
      " Certificate of completion",
    ],
  },
  {
    title: "Iot And Big Data",
    description:
      "Learn about the fundamentals of Cloud Computing and " +
      "get started with building the Web Applications with confidence.",
    content:
      "Deployment Models , Delivery Models , Virtualization , Hosting , Different Platforms and more...",
    img: image4,
    creator: "Yashraj verma",
    course_content: [
      "3 hours+ on-demand video content",
      " 14 hands-on-keyboard exercises",
      " This course + all other course access (CareerGrads)",
      " Full lifetime access (Purchase On CareerGrads)",
      " Certificate of completion",
    ],
  },
  {
    title: "Machine Learning",
    description:
      "Learn about the fundamentals of Cloud Computing and " +
      "get started with building the Web Applications with confidence.",
    content:
      "Python Fundamentals , Python Libraries , NumPy , Pandas , Keras , Tensorflow and more...",
    img: image5,
    creator: "Yashraj verma",
    course_content: [
      "3 hours+ on-demand video content",
      " 14 hands-on-keyboard exercises",
      " This course + all other course access (CareerGrads)",
      " Full lifetime access (Purchase On CareerGrads)",
      " Certificate of completion",
    ],
  },
  {
    title: "Java Development OOPs",
    description:
      "Learn about the fundamentals of Cloud Computing and " +
      "get started with building the Web Applications with confidence.",
    content:
      "Core Java , Object Oriented Concepts , JDBC , Uses of Java and more...",
    img: image6,
    creator: "Yashraj verma",
    course_content: [
      "3 hours+ on-demand video content",
      " 14 hands-on-keyboard exercises",
      " This course + all other course access (CareerGrads)",
      " Full lifetime access (Purchase On CareerGrads)",
      " Certificate of completion",
    ],
  },
];

export default data;
